import { RadioItem } from '@agro-club/agroclub-shared'
import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { ProfileType } from 'modules/domain/user/types'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { FormInput } from 'views/components/form/FormInput'
import { FormRadio } from 'views/components/form/FormRadio'
import { ResponsiveModal } from 'views/components/ResponsiveModal/ResponsiveModal'
import { CommonFields } from './CommonFields'

type Props = {
  onClose: () => void
  onSuccess: (res?: any) => void
  companyId?: string
  initProfileType?: ProfileType
}

export const AddContactModal: FC<Props> = ({ onClose, onSuccess, companyId, initProfileType }) => {
  const { t } = useTranslation(['common', 'user'])
  const { formProgress, formHandler } = useAFormHandler()

  const formik = useFormik({
    initialValues: {
      phone: null,
      is_mobile_phone: false,
      position: null,
      email: '',
      is_main: false,
      profile: {
        first_name: null,
        last_name: null,
        profile_type: initProfileType || ProfileType.customer,
        company: companyId,
      },
    },

    onSubmit: formHandler((values) => apiClient.post(endpoints.users(), values), {
      onSuccess: (res) => {
        onSuccess(res)
        onClose()
      },
      onError: (error) => {
        const { errors } = error
        formik.setErrors(errors)
      },
    }),
  })

  return (
    <ResponsiveModal
      id="addContact"
      onClose={onClose}
      title={t('addContact')}
      progress={formProgress}
      onConfirm={formik.submitForm}
    >
      <CommonFields formik={formik}>
        <FormRadio label={t('user:form.fields.profile_type')} formik={formik} field="profile.profile_type">
          <RadioItem
            disabled={!!initProfileType}
            value={ProfileType.seller}
            label={t('user:form.usProfileType.seller')}
          />
          <RadioItem
            disabled={!!initProfileType}
            value={ProfileType.customer}
            label={t('user:form.usProfileType.customer')}
          />
          <RadioItem
            disabled={!!initProfileType}
            value={ProfileType.manager}
            label={t('user:form.usProfileType.manager')}
          />
        </FormRadio>
        <FormInput label={t('common:firstName')} formik={formik} field="profile.first_name" required />
        <FormInput label={t('common:lastName')} formik={formik} field="profile.last_name" required />
      </CommonFields>
    </ResponsiveModal>
  )
}
